<template>
  <v-navigation-drawer v-model="drawer" :clipped="false" :mini-variant="mini" mobile-break-point="720" persistent enable-resize-watcher class="header-toolbar" fixed app>
    <v-list dense nav>
      <v-list-item-group color="primary" v-model="item">
        <v-list-item inactive class="title-list-item mb-0" disabled>
          <v-list-item-content class="pt-0">
            <v-list-item-title class="title d-flex justify-start align-end mb-0">
              <v-img :src="logo" max-height="80" max-width="37" class="mr-2" /> <span :style="{'marginBottom': '5px'}">Новая Энергетика</span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider color="primary" class="mb-8 ml-3 mr-3"></v-divider>
        <v-list-item v-for="(item, i) in fullMenu" :key="i" @click="$router.push(item.path); setMenuItem()" :class="item.class">
          <v-list-item-action>
            <v-icon v-html="item.icon" />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title :class="item.titleClass" v-text="item.title" />
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import { mapGetters } from 'vuex'
import logo from '@/assets/images/logo-ne_badge.png'
export default {
  name: 'LeftDrawer',

  props: {

    opened: {
      default: null,
      type: Boolean
    },

    miniVariant: {
      default: false,
      type: Boolean
    },

    menuItems: {
      default: () => [],
      type: Array
    }
  },

  data: () => ({
    item: 1,
    logo: logo
  }),

  watch: {
    $route(to, from) {
      let m = 0
      for (m in this.fullMenu) {
        if (to.path == this.fullMenu[m].path) this.item = parseInt(m) + 1
      }
    }
  },

  computed: {

    mini: {
      get: function() {
        return this.miniVariant
      },
      set: function(newValue) {
        this.$emit('update:mini-variant', newValue)
      }
    },

    drawer: {
      get: function() {
        return this.opened
      },
      set: function(newValue) {
        this.$emit('update:opened', newValue)
      }
    },

    ...mapGetters({
      services: 'common/services',
      isLoggedIn: 'user/isAuthenticated',
      userRoles: 'user/userRoles'
    }),

    groupServices: function() {
      let res = {}
      for (var service in this.services) {
        if (!(this.services[service].group in res)) {
          res[this.services[service].group] = []
        }
        res[this.services[service].group].push(this.services[service])
      }
      return res
    },

    fullMenu: function() {
      let res = []
      for (let m in this.menuItems) {
        res.push(this.menuItems[m])
        for (let s in this.groupServices[this.menuItems[m].services_name]) {
          let obj = this.groupServices[this.menuItems[m].services_name][s]
          obj['path'] = `/service/${obj.id}`
          obj['title'] = obj.name
          obj['titleClass'] = 'sub-item-title'
          obj['class'] = 'sub-item'
          if (this.hasAccess(obj['mode']) || this.userRoles.includes('superuser')) res.push(obj)
        }
      }
      return res
    }
  },
  mounted: function() {
    this.setMenuItem()
    //if (window.innerWidth < 500) {
    //this.opened = false
    //}
  },
  methods: {
    setMenuItem: function() {
      let m = 0
      for (m in this.fullMenu) {
        if (window.location.pathname.indexOf(this.fullMenu[m].path) == 0) {
          this.item = parseInt(m) + 1
          if (window.location.pathname == this.fullMenu[m].path) return
        }
      }
    },
    hasAccess: function(mode) {
      if (mode != 'common') {
        if (mode == 'private') return this.userRoles.includes('superuser')
        else return this.userRoles.includes(mode) || this.userRoles.includes('superuser')
      } else return true
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.header-toolbar {
  border-right: solid #007BBC 1px !important;
}

.main-icon {
  font-size: 24pt !important;
  color: #fd7e14 !important;
}

.title-list-item {
  color: rgba(0, 0, 0, 1) !important;
}

.sub-item-title {
  /*color: #dcdcdc;*/
  font-weight: 400 !important;
}

@media (max-width: 720px) {
  .sub-item {
    display: none;
  }
}
</style>